import type { PropsWithChildren } from "react";

import type { SelectedItem } from "../types";

// IAS overlay: no "Getting Started" section in the main navbar sidebar.
export const GettingStartedSection = (
  _props: PropsWithChildren<{
    nonEntityItem: SelectedItem;
    onAddDataModalOpen: () => void;
  }>,
) => null;
